import ReactDOM from 'react-dom';
import { tosAccelerate } from '../../../utils/tosAccelerate';

export interface PreviewAsset {
  type: 'image' | 'video' | 'audio';
  url: string;
  name?: string;
}

interface AssetPreviewLightboxProps {
  asset: PreviewAsset | null;
  onClose: () => void;
}

// 通用素材预览：图片/视频/音频。模式同 ImagePreviewLightbox（portal + 暗色遮罩，点遮罩关闭），
// 视频/音频控件上的点击不冒泡，避免误关。
export default function AssetPreviewLightbox({ asset, onClose }: AssetPreviewLightboxProps) {
  if (!asset) return null;

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 2000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', cursor: 'zoom-out' }}
    >
      {asset.type === 'image' ? (
        <img
          src={tosAccelerate(asset.url)}
          alt={asset.name || 'preview'}
          style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: 'var(--radius)' }}
        />
      ) : asset.type === 'video' ? (
        <video
          src={tosAccelerate(asset.url)}
          controls
          autoPlay
          onClick={e => e.stopPropagation()}
          style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: 'var(--radius)', background: '#000', cursor: 'default' }}
        />
      ) : (
        <audio
          src={tosAccelerate(asset.url)}
          controls
          autoPlay
          onClick={e => e.stopPropagation()}
          style={{ width: 'min(480px, 90vw)', cursor: 'default' }}
        />
      )}
      {asset.name && (
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.85rem', maxWidth: '90vw', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {asset.name}
        </div>
      )}
    </div>,
    document.body
  );
}
